// extracted by mini-css-extract-plugin
export default {"absoluteWrapper":"RelativeCentered_absoluteWrapper__ceY0x","relativeWrapper":"RelativeCentered_relativeWrapper__LN9sy"};